<template>
  <div class="modal fade" id="pinpointSearch" tabindex="-1" role="dialog"  aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="color-line"></div>
        <div class="modal-header">
          <h4 class="modal-title">Pinpoint leading-edge experts</h4>
        </div>
        <div class="modal-body">

          <div class="row" style="margin-top: 25px">
            <h5 class="text-center" >In order to identify experts and related publications, start by entering some keywords related to their desired expertise</h5>
            <div class="col-xs-12 text-left" style="margin-top: 15px">
              <simple ref="search" v-model="query" :submit-button="submit" :launchSearch="launchSearch" :placeholder="'Enter search topics in English, e.g. image sensor'" :help-keywords="true" :in-modal="true"></simple>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-info" @click="$refs.search.submitSearch(null)">Launch search</button>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import Simple from './Simple'

export default {
  name: 'PinpointExperts',
  props: [],
  components: {
    Simple
  },
  data () {
    return {
      query: null,
      submit: {
        loading: false,
        'dataStyle': 'zoom-in'
      }
    }
  },
  methods: {
    launchSearch: function (type) {
      $('#pinpointSearch').modal('hide')

      this.$router.push({ name: 'Search', params: {query: this.query}})
    }
  },
  mounted () {
    this.query = typeof this.$route.query.query !== 'undefined' ? this.$route.query.query : null

    $('#pinpointSearch').modal('show')
    $('#pinpointSearch').on('hidden.bs.modal', () => {
      this.$emit('onClose', true)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/search/PinpointExperts.vue